import { render } from "./ow-client-types.vue?vue&type=template&id=2112d9d0"
import script from "./ow-client-types.vue?vue&type=script&lang=js"
export * from "./ow-client-types.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__